module.exports = __webpack_public_path__ + "static/media/swedenMap.43c84ab7.PNG";